import React, {type ReactNode} from 'react'
import {IAuthState} from '@/Types/auth'
import Logo from '@/Components/Assets/Logo'
import Head from '@/Components/Head'


interface Props {
    auth: IAuthState
    title?: string
    logoUrl?: string | null
    children: ReactNode
}

export default function Lightweight(
    {
        auth,
        title = '',
        logoUrl = null,
        children
    }: Props): ReactNode {
    return (<>
        <Head
            auth={auth}
            title={title}
        />
        <div className={'flex flex-col border-b border-gray-400 px-5 py-[14px]'}>
            {logoUrl ? (
                <img
                    src={logoUrl}
                    alt={'Organization logo'}
                    className={'h-[32px] w-[32px] object-contain'}
                />
            ) : (
                <Logo size={32}/>
            )}
        </div>
        <div>
            {children}
        </div>
    </>)
}
